import React from "react";
import { Checkbox, Select, Table } from "@mantine/core";
import { DEFAULT_EMPLOYEE_CONFIG } from "../utils/constants";

type EmployeeReferenceColumnSelectProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
};

type columnHeader = {
  name: string;
  relatedColumn: string;
  isTag: boolean;
};

const EmployeeReferenceColumnSelect: React.FC<
  EmployeeReferenceColumnSelectProps
> = ({ form }) => {
  const headers = ["CSV Field", "Jem Field", "Is Tag"];

  return (
    <div className="">
      <Table highlightOnHover>
        <thead className="px-6 bg-gray-50 text-gray-500 align-middle border border-solid border-gray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
          <tr>
            {headers.map((it) => (
              <th key={`tHead-${Math.random()}`}>{it}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {form.values.columnHeaders.map((row: columnHeader, index: number) => (
            <tr key={`tRow-${Math.random()}`}>
              <td key={`tData-${Math.random()}`}>{row.name}</td>
              <td key={`tData-${Math.random()}`}>
                <Select
                  key={row.name}
                  placeholder="Match To"
                  data={DEFAULT_EMPLOYEE_CONFIG}
                  defaultValue={row.relatedColumn}
                  {...form.getListInputProps(
                    "columnHeaders",
                    index,
                    "relatedColumn"
                  )}
                />
              </td>
              <td key={`tData-${row.name}-isTag`}>
                <Checkbox
                  name={`columnHeaders-${row.name}-isTag`}
                  defaultValue={row.isTag}
                  {...form.getListInputProps("columnHeaders", index, "isTag")}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default EmployeeReferenceColumnSelect;
